import React, {Component} from 'react';
import {Input} from "reactstrap";
import {ChannelLogo} from "../channels/ChannelLogo";
import {CHANNEL_INFO_BY_CHANNEL} from "../channels/channels";
import { withTranslation } from 'react-i18next';

class PlatformFilterClass extends Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
        this.backdropRef = React.createRef();
        this.state = {
            isOpen: false,
            selectedPlatforms: props.selectedPlatforms || [],
            tempSelectedPlatforms: props.selectedPlatforms || []
        };
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handlePlatformToggle = this.handlePlatformToggle.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOnlyThis = this.handleOnlyThis.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleBackdropClick = this.handleBackdropClick.bind(this);
    }

    handleBackdropClick(event) {
        if (event.target === this.backdropRef.current) {
            this.setState({
                isOpen: false,
                tempSelectedPlatforms: [...this.state.selectedPlatforms]
            });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.state.isOpen) {
            document.body.style.overflow = 'hidden';
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.body.style.overflow = '';
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            document.body.style.overflow = this.state.isOpen ? 'hidden' : '';
        }
        if (prevProps.selectedPlatforms !== this.props.selectedPlatforms) {
            this.setState({
                selectedPlatforms: this.props.selectedPlatforms || [],
                tempSelectedPlatforms: this.props.selectedPlatforms || []
            });
        }
    }

    handleClickOutside(event) {
        if (this.containerRef.current && !this.containerRef.current.contains(event.target) &&
            !this.backdropRef?.current?.contains(event.target)) {
            this.setState({
                isOpen: false,
                tempSelectedPlatforms: [...this.state.selectedPlatforms]
            });
        }
    }

    toggleDropdown() {
        this.setState({
            isOpen: !this.state.isOpen,
            tempSelectedPlatforms: [...this.state.selectedPlatforms]
        });
    }

    handlePlatformToggle(channel) {
        const { tempSelectedPlatforms } = this.state;
        const isSelected = tempSelectedPlatforms.includes(channel);
        
        if (isSelected) {
            this.setState({
                tempSelectedPlatforms: tempSelectedPlatforms.filter(p => p !== channel)
            });
        } else {
            this.setState({
                tempSelectedPlatforms: [...tempSelectedPlatforms, channel]
            });
        }
    }

    handleAccept() {
        this.setState({
            selectedPlatforms: this.state.tempSelectedPlatforms,
            isOpen: false
        });
        if (this.props.onChange) {
            this.props.onChange(this.state.tempSelectedPlatforms);
        }
    }

    handleCancel() {
        this.setState({
            tempSelectedPlatforms: [...this.state.selectedPlatforms],
            isOpen: false
        });
    }

    handleOnlyThis(channel) {
        this.setState({
            selectedPlatforms: [channel],
            tempSelectedPlatforms: [channel],
            isOpen: false
        });
        if (this.props.onChange) {
            this.props.onChange([channel]);
        }
    }

    getAvailablePlatforms() {
        const { items, channelsConnections, showChannelTypes } = this.props;
        
        // Si tenemos channelsConnections y showChannelTypes, usarlos para obtener todas las plataformas disponibles
        if (channelsConnections && showChannelTypes) {
            const { channelsAllowed } = channelsConnections;
            const availablePlatforms = channelsAllowed.filter(channel => {
                const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
                return channelInfo && showChannelTypes.includes(channelInfo.channelType);
            });
            return availablePlatforms.sort();
        }
        
        // Fallback: obtener plataformas de los items si no tenemos channelsConnections
        if (!items || items.length === 0) {
            return [];
        }
        
        const platforms = new Set();
        items.forEach(item => {
            if (item.channel) {
                platforms.add(item.channel);
            }
        });
        
        return Array.from(platforms).sort();
    }

    getDisplayText() {
        const { t } = this.props;
        const { selectedPlatforms } = this.state;
        const availablePlatforms = this.getAvailablePlatforms();
        
        if (selectedPlatforms.length === 0 || selectedPlatforms.length === availablePlatforms.length) {
            return t('platform_filter.want_to_see_all_platforms');
        }
        
        return t('platform_filter.viewing');
    }

    renderPlatformLogos() {
        const { selectedPlatforms } = this.state;
        const availablePlatforms = this.getAvailablePlatforms();
        
        if (selectedPlatforms.length === 0 || selectedPlatforms.length === availablePlatforms.length) {
            return null;
        }
        
        return selectedPlatforms.map((channel) => (
            <span key={channel} style={{ marginLeft: '8px', display: 'inline-flex', alignItems: 'center' }}>
                <ChannelLogo
                    useOld={false}
                    marginLeft={0}
                    padding={0}
                    width={20}
                    height={20}
                    hspace={0}
                    vspace={0}
                    channel={channel}
                />
            </span>
        ));
    }

    render() {
        const { t } = this.props;
        const { isOpen, tempSelectedPlatforms } = this.state;
        const availablePlatforms = this.getAvailablePlatforms();

        if (availablePlatforms.length === 0) {
            return null;
        }

        return (
            <div ref={this.containerRef} className="platform-filter-container" style={{ position: 'relative', marginBottom: '15px' }}>
                <button
                    type="button"
                    className="platform-filter-button"
                    onClick={this.toggleDropdown}
                    style={{
                        width: '100%',
                        textAlign: 'left',
                        padding: '0 1em',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '0.3em',
                        cursor: 'pointer',
                        fontSize: '1em',
                        marginBottom: '15px',
                        height: '2.3em',
                        lineHeight: '2.3em',
                        boxSizing: 'border-box'
                    }}
                >
                    <span style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        {this.getDisplayText()}
                        {this.renderPlatformLogos()}
                    </span>
                    <span style={{ marginLeft: '10px', flexShrink: 0 }}>{isOpen ? '▲' : '▼'}</span>
                </button>

                {isOpen && (
                    <>
                        <div 
                            ref={this.backdropRef}
                            className="platform-filter-backdrop"
                            onClick={this.handleBackdropClick}
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 999
                            }}
                        />
                        <div className="platform-filter-dropdown" style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            width: '100%',
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            zIndex: 1000,
                            maxHeight: '70vh',
                            minHeight: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '5px'
                        }}>
                            <ul className="multi-select-accounts" style={{ margin: 0, padding: 0, overflowY: 'auto', flex: 1, minHeight: '300px' }}>
                                {availablePlatforms.map((channel) => {
                                    const isChecked = tempSelectedPlatforms.includes(channel);
                                    const platformName = CHANNEL_INFO_BY_CHANNEL[channel]?.Spanish || channel;
                                    
                                    return (
                                        <li key={channel} style={{ position: 'relative' }}>
                                            <label className={`multi-select-item -${channel.toLowerCase()} ${isChecked ? 'checked' : ''}`}>
                                                <Input
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onChange={() => this.handlePlatformToggle(channel)}
                                                />
                                                <div className="multi-select-item-name">
                                                    <span className="logo">
                                                        <ChannelLogo
                                                            useOld={false}
                                                            marginLeft={0}
                                                            padding={0}
                                                            width={20}
                                                            height={20}
                                                            hspace={0}
                                                            vspace={0}
                                                            channel={channel}
                                                        />
                                                    </span>
                                                    {platformName}
                                                </div>
                                            </label>
                                            <span className="help_center_link" style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }}>
                                                <a 
                                                    href="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        this.handleOnlyThis(channel);
                                                    }}
                                                >
                                                    [{t('platform_filter.only_this')}]
                                                </a>
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div style={{
                                padding: '10px 15px',
                                borderTop: '1px solid #ddd',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '10px',
                                flexShrink: 0
                            }}>
                                <button
                                    type="button"
                                    className="btn -alt"
                                    onClick={this.handleCancel}
                                    style={{ 
                                        minWidth: '100px',
                                        width: '100px',
                                        height: '38px',
                                        padding: '0.375rem 0.75rem',
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        justifyContent: 'center',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    {t('platform_filter.cancel')}
                                </button>
                                <button
                                    type="button"
                                    className="btn -submit"
                                    onClick={this.handleAccept}
                                    style={{ 
                                        minWidth: '100px',
                                        width: '100px',
                                        height: '38px',
                                        padding: '0.375rem 0.75rem',
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        justifyContent: 'center',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    {t('platform_filter.accept')}
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export const PlatformFilter = withTranslation()(PlatformFilterClass);
export default PlatformFilter;
